<template>
  <div class="app-container">
    <div class="image-bg-box">
      <el-image
        class="carousel-img"
        fit="cover"
        :src="require('@/assets/icon_login_bg.png')"
      />
    </div>
    <div class="app-main">
      <div class="main-left">
        <div class="title">易农无忧</div>
        <div class="desc">让生意更简单</div>
      </div>
      <div class="main-right">
        <div v-if="state === 0">
          <login-account
            @onForgetPasswordClick="onForgetPasswordClick"
            @onRegiterClick="onRegiterClick"
          />
        </div>
        <div v-else-if="state === 1">
          <scan-code-login
            @onRegiterClick="onRegiterClick"
            @onLoginClick="onLoginClick"
          />
        </div>
        <div v-else-if="state === 2">
          <forget-password @onLoginClick="onLoginClick" />
        </div>
        <div v-else-if="state === 3">
          <regiter @onLoginClick="onLoginClick" />
        </div>
        <div v-if="state === 0 || state === 1" class="right-tips">
          <div class="login-scan" @click="onChangeClick">
            <img
              v-if="state === 1"
              class="image"
              src="@/assets/icon_login_user.png"
            />
            <img v-else class="image" src="@/assets/icon_login_scan.png" />
          </div>
          <div class="login-qr" @click="onChangeClick">
            <img
              v-if="state === 1"
              class="image"
              src="@/assets/icon_login_user_image.png"
            />
            <img v-else class="image" src="@/assets/icon_login_qr.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginAccount from "./components/loginaccount.vue";
import ForgetPassword from "./components/forgetpassword.vue";
import Regiter from "./components/regiter.vue";
import ScanCodeLogin from "./components/scancodelogin.vue";
export default {
  name: "Login",
  components: {
    LoginAccount,
    ForgetPassword,
    Regiter,
    ScanCodeLogin,
  },
  data() {
    return {
      state: 0, //0:账户密码登录，1:扫码登录，2:忘记密码,3:注册
    };
  },
  methods: {
    //切换
    onChangeClick() {
      this.state = this.state === 0 ? 1 : 0;
    },
    //忘记密码
    onForgetPasswordClick() {
      this.state = 2; 
    },
    //去登录
    onLoginClick() {
      this.state = 0;
    },
    //注册
    onRegiterClick() {
      this.state = 3;
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  .image-bg-box {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    .carousel-img {
      width: 100%;
      height: 100%;
    }
  }
  .app-main {
    position: fixed;
    left: 50%;
    margin-left: -660px;
    margin-top: -250px;
    top: 50%;
    width: 1320px;
    min-height: 500px;
    display: flex;
    align-items: center;
    .main-left {
      flex: 1;
      text-align: left;
      .title {
        color: #ffffff;
        font-size: 60px;
      }
      .desc {
        font-weight: 700;
        font-size: 80px;
        color: #ffffff;
      }
    }
    .main-right {
      width: 520px;
      min-height: 500px;
      background-color: #ffffff;
      box-shadow: 0px 0px 8px 4px rgba(16, 130, 255, 0.6);
      border-radius: 20px;
      position: relative;
      .right-tips {
        position: absolute;
        z-index: 9;
        top: 0;
        right: 0;
        display: flex;
        .login-scan {
          margin-top: 10px;
          cursor: pointer;
          margin-right: -10px;
          .image {
            height: 30px;
          }
        }
        .login-qr {
          cursor: pointer;
          .image {
            width: 77px;
            height: 77px;
          }
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/login/index.vue